import { IconButton, Intent } from '@toilet-paper-games/ui';
import { MessageSquareWarning } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useCallback, useState } from 'react';
import { FeedbackDialog } from './dialogs/FeedbackDialog';

export const FeedbackButton = observer(() => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleFeedbackClick = useCallback(() => {
    setIsDialogOpen(true);
  }, [setIsDialogOpen]);

  return (
    <>
      <IconButton icon={<MessageSquareWarning />} onClick={handleFeedbackClick} shadow>
        Give Feedback
      </IconButton>
      <FeedbackDialog open={isDialogOpen} onOpenChange={setIsDialogOpen} />
    </>
  );
});
